import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UploadStudentListComponent } from '../upload-student-list/upload-student-list.component';

export type SearchResultsItem = {
	name: string;
	isSelectable: boolean;
	isEditable: boolean;
	id?: number;
	img?: string;
	details?: string;
	disabledCheckmark?: boolean;
	disabledMessage?: string;
};
export type ResultsKey = 'group' | 'student' | 'other';
export type ResultsGroup = {
	key: ResultsKey;
	title?: string;
	items: SearchResultsItem[];
};
export type SelectedItem = { item: SearchResultsItem; resultKey: ResultsKey };

@Component({
	selector: 'bp-student-search-results',
	template: `
		<sp-upload-student-list (handleClick)="uploadStudentListClicked.emit()"></sp-upload-student-list>
		<ng-container *ngFor="let group of itemGroups">
			<div *ngIf="group.title" class="tw-text-gray-500">{{ group.title }}</div>
			<ng-container *ngFor="let item of group.items">
				<div
					class="tw-text-gray-500 tw-box-border tw-w-full hover:tw-bg-gray-050 "
					style="border-radius: 10px;"
					[ngClass]="{ 'tw-opacity-50 tw-cursor-default': !item.isSelectable, 'tw-cursor-pointer': item.isSelectable }"
					(mousedown)="itemSelected.emit({ item: item, resultKey: group.key })">
					<div class="tw-flex tw-items-center tw-gap-2 tw-box-border tw-h-[52px] tw-px-2">
						<div class="tw-flex tw-items-center" *ngIf="item.img">
							<img class="tw-rounded-full tw-h-[28px] tw-w-[28px]" [src]="item.img" />
						</div>
						<div class="tw-flex tw-flex-grow tw-justify-between tw-items-center tw-leading-none">
							<div class="tw-font-medium tw-text-navy-500 tw-text-[15px] tw-leading-none">{{ item.name }}</div>
							<div class="tw-font-light tw-text-sm tw-text-navy-500 tw-leading-none" *ngIf="item.details">{{ item.details }}</div>
						</div>
						<div class="tw-flex tw-items-center tw-gap-[2px] tw-max-w[153px]" *ngIf="item.disabledMessage">
							<img *ngIf="item.disabledCheckmark" src="assets/Check (Gray).svg" height="12" width="12" alt="{{ item.disabledMessage }}" /><span
								class="tw-text-sm tw-text-gray-500 tw-whitespace-nowrap tw-overflow-ellipsis tw-overflow-hidden"
								>{{ item.disabledMessage }}</span
							>
						</div>
					</div>
				</div>
				<div *ngIf="itemGroups?.length === 0">
					<div class="tw-text-gray-500 tw-font-medium tw-text-center tw-text-base tw-w-full tw-py-[60px]">No results found</div>
				</div>
			</ng-container>
		</ng-container>
	`,
	styles: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [UploadStudentListComponent, CommonModule],
})
export class StudentSearchResultsComponent {
	@Input() itemGroups: ResultsGroup[] = [];

	@Output() itemSelected: EventEmitter<SelectedItem> = new EventEmitter<SelectedItem>();
	@Output() uploadStudentListClicked: EventEmitter<void> = new EventEmitter<void>();
}
